export const properties = {
    //server: "http://localhost:7029/facele/"
    server: "https://facturacionelectronica.jaivana.co/facele/"
}